<!-- 企业到期蒙层组件 - 用于敏感操作页面 -->
<template>
    <div v-if="loading || isExpired" class="corp-expire-mask">
        <!-- loading 状态 -->
        <div v-if="loading" class="corp-expire-mask__loading">
            <v-spinner />
        </div>
        <!-- 到期提示 -->
        <div v-else class="corp-expire-mask__content">
            <v-icon
                class="corp-expire-mask__icon"
                name="basic_warning_fill"
                size="48"
                remote
            />
            <div class="corp-expire-mask__title">
                {{ $t('服务已到期') }}
            </div>
            <div class="corp-expire-mask__desc">
                {{ $t('当前企业服务已到期，暂无法使用此功能。') }}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { checkCorpExpire } from './utils';

export default Vue.extend({
    name: 'CorpExpireMask',

    data() {
        return {
            isExpired: false,
            loading: true,
        };
    },

    mounted() {
        this.checkExpireStatus();
    },

    beforeDestroy() {
        // 组件销毁时清除定时器，防止内存泄漏
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    },

    methods: {
        checkExpireStatus() {
            // 用 Promise 封装：接口请求与 3s 超时谁先完成就用谁的结果
            new Promise((resolve) => {
                // 超时保护
                this._timer = setTimeout(() => {
                    this._timer = null;
                    resolve({ isExpired: false, timeout: true });
                }, 3000);

                // 发起接口请求
                checkCorpExpire()
                    .then((result) => {
                        resolve(result || { isExpired: false });
                    })
                    .catch((error) => {
                        console.error('[CorpExpireMask] 检查企业到期状态失败:', error);
                        resolve({ isExpired: false });
                    });
            }).then((result) => {
                if (this._isDestroyed) return;

                // 清除定时器（先完成的一方清除另一方）
                if (this._timer) {
                    clearTimeout(this._timer);
                    this._timer = null;
                }

                if (result.timeout) {
                    console.warn('[CorpExpireMask] 检查企业到期状态超时（>3s），跳过蒙层展示');
                }

                this.isExpired = !!result.isExpired;
                this.loading = false;
            });
        },
    },
});
</script>

<style lang="less" scoped>
.corp-expire-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.93);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: not-allowed;
    width: 100%;
    height: 100vh;
    overflow: hidden;

    &__loading {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__content {
        text-align: center;
        padding: 40px;
    }

    &__icon {
        color: #faad14;
        margin-bottom: 16px;
    }

    &__title {
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 8px;
    }

    &__desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-bottom: 24px;
        max-width: 300px;
    }
}
</style>
